/**
 * Nội dung thanh toán
 */
export default {
  DescriptionDetail: 'description', // Diễn giải chi tiết
  BudgetSubItemName: 'budget_sub_item_name', // Tên tiểu mục
  BudgetItemNameAndBudgetSubItemName: 'budget_item_name', // Tên mục và Tên tiểu mục
  DescriptionVoucher: 'journal_memo', // Diễn giải chứng từ
};
